import Api from '@/services/Api';
import _ from 'lodash';
import MetodosGlobais from '@/utils/MetodosGlobais';

const RECURSO = '/folhasDePagamentos';


export default {
    buscarConsolidadoPorTipoRegime,
    buscarConsolidadoPorEscolaridade,
    buscarConsolidadoPorTipoRacaSexo,
    buscarConsolidadoPorOrgao,
    buscarConsolidadoPorCargo,
    buscarServidoresPorFaixaEtaria,
    buscarHistoricoAdmissoesVacanciasDosServidores,
    buscarHistoricoAdmissoesDosServidoresNoIntervalo,
    buscarHistoricoVacanciasDosServidoresNoIntervalo,
    buscarHistoricoAposentadoriasDosServidoresNoIntervalo,
    buscarHistoricoServidoresPorCaracteristicasNoIntervalo,
    buscarHistoricoAdmissoesVacanciasDosServidoresPorRaca,
    buscarFolhaPagamentoProfessoresConsolidadoPorTipoRegime,
    buscarFolhaPagamentoProfessoresConsolidadoPorCargo,
    buscarFolhaPagamentoProfessoresPorRegimeDeContratacao,
    buscarFolhaPagamentoProfessoresConsolidadoPorRacaSexo,
    buscarFolhaPagamentoProfessoresPorFaixaEtariaServidores,
    distribuicaoPorRegimeContratacao
};


function buscarConsolidadoPorTipoRegime({dataInicio, dataFim}){
    let params = {'dataInicio ': dataInicio, 'dataFim ': dataFim};
    return Api.get(`${RECURSO}/consolidadoPorTipoRegime${MetodosGlobais.createEncodeQuery(params)}`)
}
function buscarConsolidadoPorEscolaridade({dataInicio, dataFim, agrupamento}){
    let params = {'dataInicio ': dataInicio, 'dataFim ': dataFim, 'agrupamento': agrupamento };
    return Api.get(`${RECURSO}/consolidadoPorEscolaridade${MetodosGlobais.createEncodeQuery(params)}`)
}
function buscarConsolidadoPorTipoRacaSexo({dataInicio, dataFim, agrupamento}){
    let params = {'dataInicio ': dataInicio, 'dataFim ': dataFim, 'agrupamento': agrupamento };
    return Api.get(`${RECURSO}/consolidadoPorRacaSexo${MetodosGlobais.createEncodeQuery(params)}`)
}
function buscarConsolidadoPorOrgao({dataInicio, dataFim}){
    let params = {'dataInicio ': dataInicio, 'dataFim ': dataFim};
    return Api.get(`${RECURSO}/consolidadoPorOrgao${MetodosGlobais.createEncodeQuery(params)}`)
}
function buscarConsolidadoPorCargo({dataInicio, dataFim}){
    let params = {'dataInicio ': dataInicio, 'dataFim ': dataFim};
    return Api.get(`${RECURSO}/consolidadoPorCargo${MetodosGlobais.createEncodeQuery(params)}`)
}
function buscarServidoresPorFaixaEtaria({agrupamento,dataInicio, dataFim}){
    let params = {'agrupamento': agrupamento, 'dataInicio ': dataInicio, 'dataFim ': dataFim };
    return Api.get(`${RECURSO}/faixaEtariaAtivos${MetodosGlobais.createEncodeQuery(params)}`)
}
function buscarHistoricoAdmissoesVacanciasDosServidores(){
    return Api.get(`${RECURSO}/historicosServidores/admissoesEVacancias`)
}
function buscarHistoricoAdmissoesDosServidoresNoIntervalo({dataInicio, dataFim}){
    let params = {'dataInicio': dataInicio, 'dataFim': dataFim };
    return Api.get(`${RECURSO}/historicosServidores/admissoesNoIntervalo${MetodosGlobais.createEncodeQuery(params)}`)
}
function buscarHistoricoVacanciasDosServidoresNoIntervalo({agrupamento, dataInicio, dataFim}){
    let params = {'agrupamento': agrupamento, 'dataInicio': dataInicio, 'dataFim': dataFim };
    return Api.get(`${RECURSO}/historicosServidores/vacanciasNoIntervalo${MetodosGlobais.createEncodeQuery(params)}`)
}
function buscarHistoricoAposentadoriasDosServidoresNoIntervalo({dataInicio, dataFim}){
    let params = {'dataInicio': dataInicio, 'dataFim': dataFim };
    return Api.get(`${RECURSO}/historicosServidores/aposentadoriasNoIntervalo${MetodosGlobais.createEncodeQuery(params)}`)
}
function buscarHistoricoServidoresPorCaracteristicasNoIntervalo({dataReferencia, agrupamento, dataInicio, dataFim}){
    let params = {'dataReferencia': dataReferencia, 'agrupamento': agrupamento, 'dataInicio': dataInicio, 'dataFim': dataFim };
    return Api.get(`${RECURSO}/historicosServidores/servidoresPorCaracteristicasNoIntervalo${MetodosGlobais.createEncodeQuery(params)}`)
}
function buscarHistoricoAdmissoesVacanciasDosServidoresPorRaca({dataInicio, dataFim}){
    let params = {'dataInicio': dataInicio, 'dataFim': dataFim };
    return Api.get(`${RECURSO}/historicosServidores/admissoesEVacanciasPorRaca${MetodosGlobais.createEncodeQuery(params)}`)
}
function buscarFolhaPagamentoProfessoresConsolidadoPorTipoRegime({dataInicio, dataFim}){
    let params = {'dataInicio': dataInicio, 'dataFim': dataFim };
    return Api.get(`${RECURSO}/professores/consolidadoPorTipoRegime${MetodosGlobais.createEncodeQuery(params)}`)
}
function buscarFolhaPagamentoProfessoresConsolidadoPorCargo({dataInicio, dataFim, regime}){
    let params = {'dataInicio': dataInicio, 'dataFim': dataFim, 'regime': regime };
    return Api.get(`${RECURSO}/professores/consolidadoPorCargo${MetodosGlobais.createEncodeQuery(params)}`)
}
function buscarFolhaPagamentoProfessoresPorRegimeDeContratacao({dataInicio, dataFim}){
    let params = {'dataInicio': dataInicio, 'dataFim': dataFim };
    return Api.get(`${RECURSO}/professores/regimeContratacao${MetodosGlobais.createEncodeQuery(params)}`)
}
function buscarFolhaPagamentoProfessoresConsolidadoPorRacaSexo({dataInicio, dataFim, regime}){
    let params = {'dataInicio': dataInicio, 'dataFim': dataFim, 'regime': regime };
    return Api.get(`${RECURSO}/professores/consolidadoPorRacaSexo${MetodosGlobais.createEncodeQuery(params)}`)
}
function buscarFolhaPagamentoProfessoresPorFaixaEtariaServidores({dataInicio, dataFim, regime}){
    let params = {'dataInicio': dataInicio, 'dataFim': dataFim, 'regime': regime };
    return Api.get(`${RECURSO}/professores/faixaEtariaAtivos${MetodosGlobais.createEncodeQuery(params)}`)
}

function distribuicaoPorRegimeContratacao({dataInicio, dataFim, agrupamento}){
    let params = {'dataInicio ': dataInicio, 'dataFim ': dataFim, 'agrupamento': agrupamento };
    return Api.get(`${RECURSO}/distribuicaoPorRegimeContratacao${MetodosGlobais.createEncodeQuery(params)}`)
}